// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"styles_spinnerContainer__ii19Z","spinner":"styles_spinner__dt+kf"};